import { FC, ReactNode } from 'react';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { InputProps, withField } from '../withField';

interface Option {
  label: string | ReactNode;
  id: string;
}

interface ButtonRadioInputProps {
  options: Option[];
}

export const ButtonRadioInput: FC<InputProps<string> & ButtonRadioInputProps> = ({ options, value, onChange, id }) => {
  return (
    <div role="radiogroup" aria-label={id} className="flex flex-wrap gap-2">
      {options.map(option => (
        <Button
          key={option.id}
          variant={option.id === value ? ButtonVariant.Primary : ButtonVariant.Mono}
          type="button"
          role="radio"
          aria-checked={option.id === value}
          onClick={() => onChange(option.id)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};

export const ButtonRadioField = withField<string, ButtonRadioInputProps>(ButtonRadioInput);
